import React, {Component} from 'react'
import TextField1 from '../Textfield1/Textfield1';
import {useField} from "formik";

class OtherWrapper extends Component {
shouldComponentUpdate(nextProps) { 
    // Rendering the component only if  
    // passed props value is changed 
  
    if (nextProps.value !== this.props.value) { 
      return true; 
      console.log("nextProps.value");
      console.log(this.props.value);
    } else { 
      return false; 
      console.log(nextProps.value);
      console.log("nextProps.value");
      console.log(this.props.value);
    } 
    }
    
  render() {
    console.log("chinihi eli chinhi");
    const { label, name, ...attributes } = this.props;
    // const err = getIn([errors, name]);
    // const touch = getIn([touched, name]);
    return (
      <TextField1 
      name={name}
      label={label}
      />
      
    );
  }
}
export default  OtherWrapper;